// extracted by mini-css-extract-plugin
export default {"insights-charts-and-table":"Insights_insights-charts-and-table__lDgPU","insights-global-filters-and-legend":"Insights_insights-global-filters-and-legend__NwO+A"};